import addSubOrderGroup from '../../../../../Services/addSubOrderGroup'

export default () => (dispatch) => {

  dispatch(addSubOrderGroup())

}
